import { faGift, faInfoCircle, faShareSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import Link from 'next/link'
import React, { useContext, useEffect } from 'react'
import Context from '../../utils/Context'
import { DiaperBankPublic } from '../../utils/DiaperBankDTO'
import { gaEvent } from '../../utils/GA'
import { moneyFormatter } from '../../utils/MoneyFormatter'
import Tooltip from '../../utils/Tooltip'
import Button from '../form/Button'
import Truncate from '../Truncate'
import Contributions from './Contributions'
import EditProfileDropdown from './EditProfileDropdown'
import Photos from './Photos'
import ProgressMeter from './ProgressMeter'
import PublicUpdates from './PublicUpdates'
import Share from './Share'
import Subscriptions from './Subscriptions'
import VerificationModal from './VerificationModal'

const PublicProfile = ({ diaperBank, isPublic }: { diaperBank: DiaperBankPublic; isPublic: boolean }) => {
  const context = useContext(Context)
  useEffect(() => {
    gaEvent({
      action: isPublic ? 'df_profile_view_public' : 'df_profile_view_private',
      params: {
        event_label: diaperBank.slug,
      },
    })
  }, [])

  const userIsAdminOfThisDiaperBank = context.jwtToken?.ownedDiaperBankSlugs?.includes(diaperBank.slug)
  const userIsAdminViewingAsPublic = userIsAdminOfThisDiaperBank && context.role === 'admin' && isPublic
  return (
    <>
      {!diaperBank.isVerified && !isPublic && <VerificationModal diaperBank={diaperBank} />}

      {userIsAdminViewingAsPublic && (
        <Link href={`/bank/${diaperBank.slug}`}>
          <a className='text-center py-2 -mb-6 bg-wisteria-light text-xs w-full block md:max-w-md m-auto'>Back to Admin View</a>
        </Link>
      )}

      <div className={classNames('pb-12', { 'pt-6': userIsAdminViewingAsPublic })}>
        <Photos diaperBank={diaperBank} isPublic={isPublic} />
        <div className='px-4'>
          {!isPublic && <EditProfileDropdown diaperBank={diaperBank} />}
          <h1 className='my-4 font-semibold text-xl'>{diaperBank?.babyName}'s Diaper Fund</h1>
          <Truncate text={diaperBank.description} className='text-sm my-4 text-gray-700 text-justify font-light' />
          {!isPublic && !!diaperBank.balance && (
            <div className='my-6'>
              <span className='text-base font-semibold'>Balance:</span> <span className='text-sm'>{moneyFormatter.format(diaperBank.balance)}</span>{' '}
              <Tooltip button={<FontAwesomeIcon icon={faInfoCircle} />}>The balance can be used for any Hello Bello bundles and products, except gift cards.</Tooltip>
            </div>
          )}
          <ProgressMeter diaperBank={diaperBank} />

          <PublicUpdates diaperBank={diaperBank} isPublic={isPublic} />

          <Contributions diaperBank={diaperBank} />
          <Subscriptions diaperBank={diaperBank} />
          <div className='w-full fixed md:sticky bottom-0 bg-white z-10 p-4 md:px-0 border-t  border-gray-100 -mx-4 md:mx-0 flex gap-x-2'>
            <Share diaperBank={diaperBank}>
              {(onClick) => (
                <Button onClick={onClick} outline icon={<FontAwesomeIcon icon={faShareSquare} />}>
                  Share
                </Button>
              )}
            </Share>
            <div className='flex-grow'>
              <Link href={`/bank/${diaperBank.slug}/contribute`}>
                <a className='btn btn-primary w-full'>
                  {/* <i className='fal fa-gift mr-2'></i> */}
                  <div className='flex-1 align-top'>
                    <div className='h-4 inline-block mr-2'>
                      <FontAwesomeIcon icon={faGift} className='stroke-current' />
                    </div>
                    <div className='h-4 inline-block'>Contribute</div>
                  </div>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PublicProfile
